<template>
  <div class="sidebar-content -slider">
    <div class="js-price-rangeSlider">
      <div class="px-5">
        <div ref="slider" class="js-slider"></div>
      </div>

      <div class="mt-25">
        <div class="d-flex items-center justify-between text-14">
          <span>Min Price: <span>{{ lowerPrice }}</span></span>
          <span>Max Price: <span>{{ upperPrice }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  name: 'PriceRangeSlider',
  data() {
    return {
      lowerPrice: '$0',
      upperPrice: '$500',
    };
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const slider = this.$refs.slider;

      noUiSlider.create(slider, {
        start: [0, 500],
        step: 100,
        connect: true,
        range: {
          min: 0,
          max: 2000,
        },
        format: {
          to: (value) => `$${value}`,
          from: (value) => parseFloat(value.replace('$', '')),
        },
      });

      slider.noUiSlider.on('update', (values) => {
        this.lowerPrice = values[0];
        this.upperPrice = values[1];
        this.$emit('priceUpdate', { lowerPrice: values[0], upperPrice: values[1] });
      });
    },
  },
};
</script>